<template>
  <div>
    <zm-drawer
      :visible="visible"
      :title="title"
      :width="drawerWidth"
      :footer="false"
      @cancel="cancel"
    >
      <div slot="drawerBody" class="inquiry-records">
        <zm-label title="产品信息" />
        <a-row class="detail">
          <div class="detail-item">
            <div class="label">产品名称</div>
            <div class="info">{{ model.name }}</div>
          </div>
          <div class="detail-item">
            <div class="label">规格型号</div>
            <div class="info">{{ model.spec }}</div>
          </div>
          <div class="detail-item">
            <div class="label">单位</div>
            <div class="info">{{ model.unitDesc }}</div>
          </div>
        </a-row>
        <zm-label title="询价记录" />
        <div class="action-btn">
          <zm-button type="primary" icon="plus" @click="add" style="margin-right:12px;">新增</zm-button>
          <zm-button type="danger" @click="batchDel">批量删除</zm-button>
        </div>
        <zm-table
          :columns="table.columns"
          :rowKey="(record) => record.id"
          :dataSource="table.data"
          :pagination="pagination"
          :loading="table.loading"
          @change="handleTableChange"
          :rowSelection="rowSelection"
        >
          <template v-slot:actions="{ text, record }">
            <a href="javascript:;" @click="() => handleView(record)">详情</a>
            <template>
              <a-divider type="vertical" />
              <a href="javascript:;" @click="() => handleEdit(record)">编辑</a>
            </template>
            <template>
              <a-divider type="vertical" />
              <a-popconfirm v-if="table.data.length" title="确定要删除吗?" @confirm="() => onDelete(record)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </template>
        </zm-table>
      </div>
    </zm-drawer>

    <!-- 新增、编辑 -->
    <edit-record ref="editModal" @refreshTable="initData"></edit-record>
    <!-- 详情 -->
    <view-record ref="viewModal"></view-record>
    <!-- 删除提示框 -->
    <!-- <zm-modal title="" -->
  </div>
</template>

<script>
import { deleteInquiryRecord, getInquiryRecords } from '@/api/inquiry'
import editRecord from './editRecord.vue'
import ViewRecord from './viewRecord.vue'
import moment from 'moment'

const innerWidth = window.innerWidth
export default {
  components: { editRecord, ViewRecord },
  name: 'inquiryRecord',
  computed: {
    drawerWidth () {
      const width = window.innerWidth - 200
      return width
    }
  },
  data () {
    return {
      innerWidth,
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      visible: false,
      model: {},
      selectedRows: [],
      rowSelection: {
        columnWidth: 60,
        fixed: true,
        selectedRowKeys: [],
        onChange: (selectedRowKeys, selectedRows) => {
          this.rowSelection.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      table: {
        data: [
          { id: 1, inquiryTime: '2021-10-29', inquiryPrice: 19.21 },
          { id: 2, inquiryTime: '2021-10-29', inquiryPrice: 19.21 },
          { id: 3, inquiryTime: '2021-10-29', inquiryPrice: 19.21 }
        ],
        config: {},
        columns: [
          {
            title: '询价日期',
            dataIndex: 'inquiryTime',
            customRender: (text) => {
              if (text) return moment(text).format('YYYY-MM-DD')
            },
            width: '12%'
          },
          {
            title: '询价单价(元)',
            dataIndex: 'inquiryPrice',
            width: '12%'
          },
          {
            title: '供应商',
            dataIndex: 'supplierName',
            ellipsis: true,
            width: '16%'
          },
          {
            title: '联系人',
            dataIndex: 'supplierContactName',
            width: '12%'
          },
          {
            title: '联系方式',
            dataIndex: 'phone',
            width: '14%'
          },
          {
            title: '市场商机',
            dataIndex: 'marketName',
            ellipsis: true,
            width: '18%'
          },
          {
            title: '操作',
            width: '16%',
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      }
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.visible = flag
      if (flag) {
        this.initData()
      } else {
        this.formClear()
      }
    },
    setModelInfo () {},
    formClear () {
      this.table.data = []
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    async initData () {
      const params = {
        productId: this.model.id,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      this.selectedRows = []
      this.rowSelection.selectedRowKeys = []
      this.table.loading = true
      const res = await getInquiryRecords(params).catch((error) => {
        console.log('获取失败', error)
        this.$message.error('数据获取失败，请稍后重试！')
      })
      this.table.loading = false
      if (res.status === 0) {
        this.table.data = res.data.list
        this.pagination.total = res.data.total
      } else {
        this.$message.warning(res.info.message)
      }
    },
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.initData()
    },

    // 新增记录
    add () {
      this.$refs.editModal.setTitle('新增询价记录')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD)
      this.$refs.editModal.setModel({ productId: this.model.id }) // 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 批量删除
    batchDel () {
      const selectedKeys = this.rowSelection.selectedRowKeys
      if (!selectedKeys || selectedKeys.length === 0) {
        this.$message.warning('请至少选择一行数据进行删除！')
        return
      }
      const _this = this
      this.$confirm({
        title: `确定要删除这些记录吗?`,
        onOk: () => {
          const params = selectedKeys.join(',')
          _this.deleteFn(params)
        }
      })
    },
    // 详情
    handleView (record) {
      this.$refs.viewModal.setTitle('查看询价记录')
      this.$refs.viewModal.setModel({ ...record, productId: this.model.id }) // 先设置类型，再打开
      this.$refs.viewModal.open(true)
    },
    // 编辑
    handleEdit (record) {
      this.$refs.editModal.setTitle('编辑询价记录')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editModal.setModel({ ...record, productId: this.model.id }) // 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    async deleteFn (ids) {
      const res = await deleteInquiryRecord(ids).catch((err) => {
        console.log('初始化失败', err)
      })
      if (res && res.status === 0) {
        this.$message.success(res.info.message)
        this.initData()
      } else {
        this.$message.error(res.info.message)
      }
    },
    // 删除
    onDelete (record) {
      this.deleteFn(record.id)
    }
  }
}
</script>

<style lang="less">
.inquiry-records{
  .zm-label{
    margin-bottom: 12px;
  }
  .detail{
    display: flex;
    margin-bottom: 32px;
    .detail-item{
      display: flex;
      .label{
        color: #B3B3B3;
        margin-right: 12px;
      }
      .info{
        margin-right: 100px;
      }
    }
  }
  .action-btn{
    margin-bottom: 16px;
  }
}
</style>
